<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M9.99455 18L13.3392 12H6.6499L9.99455 18Z" fill="currentColor" />
  <path d="M9.99455 2L13.3392 8H6.6499L9.99455 2Z" fill="currentColor" />
</svg>
